<template>
    <div :class="['message', type]">
        <div class="message-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Message',
    props: {
        type: { type: String, default: 'is-success' },
    },
};
</script>
